module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAIhJREFUGBltj9ERgCAMQxmBERzBkTqaX66hG+gKuggmQCvW9i5SykuEVEqZoQ3KKSjMF0jqEZodYh3Qx4A9Qa0pocvQ2SdmwH4EWzLjA8PazVxekDDLGZSVehh9QIyJFwMijsnjHe8ebW8wkwOFidDv0T5RNCE0YMgkloGBgX9p90czKeBXQgo+leYSXGjtpBsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteXButton.png
// module id = 294
// module chunks = 0